import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { log } from 'log';
import { prop } from 'ramda';
import { useGetPlayerTags, usePushSubscription } from 'server';

import { TPlayerTag } from '@core/js/hooks/socket/hooks/useGetPlayerTags/types';
import { useUserSelector } from '@core/js/store/hooks';

import { removePlayerTag, setAllPlayerTags, updatePlayerTags } from '@interlayer/js/custom/stores/user/actions';
import { fromArrayToObject } from '@interlayer/js/custom/utils/methods.util';

export const useAllPlayerTags = () => {
    const dispatch = useDispatch();
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));
    const getPlayerTags = useGetPlayerTags();

    usePushSubscription(31133, () => (pushMessage) => {
        const { notificationPlayerTagChangeInfo } = pushMessage?.data?.notification || {};

        if (notificationPlayerTagChangeInfo) {
            const { tag, removed } = notificationPlayerTagChangeInfo;

            if (removed) {
                dispatch(removePlayerTag(tag));
                return;
            }

            dispatch(updatePlayerTags({
                [tag]: notificationPlayerTagChangeInfo
            }));
        }
    });

    const fetchPlayerTags = useCallback(async () => {
        if (!isLoggedIn) {
            return;
        }

        try {
            const { tags } = await getPlayerTags();

            const tagsObject = fromArrayToObject<TPlayerTag, 'name'>({
                data: tags || [],
                key: 'name'
            });

            dispatch(setAllPlayerTags(tagsObject));
        } catch (error) {
            log('error', error);
        }
    }, [dispatch, getPlayerTags, isLoggedIn]);

    useEffect(() => {
        fetchPlayerTags();
    }, [fetchPlayerTags]);
};
